import { useLocalization } from '@/hooks/useLocalization';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import { GEO_OPTIONS } from '@/utils/constants';

export default function RegionScreen() {
  const { t } = useLocalization();
  const { chooseGeography } = useChat();

  return (
    <BotMessage text={t('geography.message')}>
      <ScreenOptions>
        {GEO_OPTIONS.map(opt => (
          <OptionButton
            key={opt.value}
            variant={opt.accent ? 'accent' : 'default'}
            onClick={() => chooseGeography(opt.value)}
          >
            {t(opt.labelKey)}
          </OptionButton>
        ))}
      </ScreenOptions>
    </BotMessage>
  );
}
